/**
 * Produkcija: prazan string (isti origin, host nginx/reverse-proxy šalje /api ka backend-u).
 * Lokalni docker bez reverse-proxy-ja: ako je API_BASE prazan, gađaj isti host na :8080.
 */
const explicitApiBase = process.env.REACT_APP_API_BASE;

function isLocalLikeHost(hostname) {
  if (!hostname) return false;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return true;
  if (hostname.startsWith('10.')) return true;
  if (hostname.startsWith('192.168.')) return true;
  if (/^172\.(1[6-9]|2\d|3[0-1])\./.test(hostname)) return true;
  return false;
}

function localApiFallback() {
  if (typeof window === 'undefined') return '';
  const { protocol, hostname } = window.location;
  if (!isLocalLikeHost(hostname)) return '';
  return `${protocol}//${hostname}:8080`;
}

export const API_BASE = explicitApiBase || localApiFallback();
